angular.module('gym.components').directive('contactInformation', function() {
  return {
    restrict: 'E',
    template: require('templates/components/contacts/contact_information.html.slim'),
    scope: {
      contact: '=',
      gocardlessDefaultMandateInvalid: '=',
      permissions: '=',
      deleteContact: '&',
      saveImage: '&',
      flags: '=',
      addFlag: '&',
      showFlags: '&',
      onFlagAdded: '&'
    },
    controller: ["$scope", "$timeout", "$document", "ContactBadgeService", "flash", function($scope, $timeout, $document, ContactBadgeService, flash) {
      $scope.getYears = function() {
        return moment().diff($scope.contact.contact_information.dob, 'years');
      };
      $scope.scrollToWallet = function() {
        return $document.scrollToElementAnimated(angular.element('#walletContainer'));
      };
      $scope.getContactBadge = function(type, status) {
        return ContactBadgeService.get(type, status);
      };
      $scope.hasPendingCancellation = function() {
        return !!_.find($scope.contact.memberships, function(item) {
          return item.active && item.membership_cancellation;
        });
      };
      $scope.scrollToMemberships = function() {
        return $document.scrollToElementAnimated(angular.element('#memberships-section-container'));
      };
      $scope.selectPhoto = function() {
        angular.element('#contact-photo-input').click();
        return true;
      };
      return $scope.$watch('imageData.file', function(file) {
        var dataUrlReader;
        if (file != null ? file.size : void 0) {
          if (file.size > 5000000) {
            flash.error = 'Image size must be 5MB or lower';
            return;
          }
          dataUrlReader = new window.FileReader();
          dataUrlReader.readAsDataURL(file);
          return dataUrlReader.onloadend = function() {
            return $timeout(function() {
              $scope.imageData.imagePreview = dataUrlReader.result;
              $scope.contact.image = dataUrlReader.result.replace(/^data:image\/\w*;base64,/, '');
              return $scope.saveImage();
            });
          };
        }
      });
    }]
  };
});
